import Column from '@components/Column';
import Header from '@components/Header';
import Image from '@components/Image';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import useCompleteAnimation from './hooks/useCompleteAnimation';
import img from './img.png';
import {
    card, container, hide, none,
} from './styles';

function Complete() {
    const ref = useRef<HTMLDivElement>(null);
    const cardRef = useRef<HTMLImageElement>(null);
    const { t } = useTranslation('gift');
    const { message } = useCompleteAnimation({ ref, cardRef });
    return (
        <div className={`${container} ${none} ${hide}`}
            ref={ref}>
            <Header noBackIcon title={t('giftOrder.completeTitle')}/>
            <CardWrapper>
                <Image src={img}
                    // @ts-ignore
                    ref={cardRef}
                    className={card}
                    alt={t('giftOrder.completeCardImageAlt')} />
            </CardWrapper>
            <Column align='center' spacing={18}>
                <Text color={colors.gray7} size='3xl' fontWeight='bold' >
                    {t('giftOrder.completeMessage')}
                </Text>
                <Message color={colors.gray7}>
                    {message}
                </Message>
            </Column>
        </div>
    );
}

const CardWrapper = styled.div`
    padding: 114px 28px 100px;
`;

const Message = styled(Text)`
    text-align: center;
    white-space: pre-line;
`;

export default Complete;
